import { WHY } from '../constants/content';
import { SITE_NAME } from '../constants/site';

export default function Why() {
  return (
    <section className="fm-section fm-section--alt" id="why">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">Why {SITE_NAME}</p>
          <h2 className="fm-sec-title">Why teams choose {SITE_NAME}</h2>
          <p className="fm-sec-lead">
            Clear licences, quick delivery, and support that stays with you after
            checkout — for both creative and marketing software.
          </p>
        </div>
        <div className="fm-why-list">
          {WHY.map((item) => (
            <article key={item.title} className="fm-why-item">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
